import React from 'react';
import {connect} from 'react-redux';
import EditPhoneInputFirstStep from './EditPhoneInputFirstStep';
import EditPhoneInputSecondStep from './EditPhoneInputSecondStep';


function EditPhoneInput(props) {
  if (props.regInputCurStep === 1) {
    return <EditPhoneInputFirstStep {...props} />;
  } else {
    return <EditPhoneInputSecondStep {...props} />;
  }
}

export default connect(
  (state) => ({
    regInputCurStep: state.registrationPopupReducer.regInputCurStep
  }),
  () => ({})
)(EditPhoneInput);



/** WEBPACK FOOTER **
 ** ./src/components/User/elements/EditPhoneInput.jsx
 **/